
import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import { pesAdminService } from '@/services/pa/pesAdminService.ts';

export interface PatientEnroller {
  patient_enroller_id: number;
  first_name: string;
  last_name: string;
  full_name: string;
  email: string;
  clinic_names: string;
  clinic_ids: number[];
  deferred_task: boolean;
  follow_up: boolean;
}

export const usePatientEnrollers = () => {
  const { hasuraToken } = useAuth();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['patientEnrollers'],
    queryFn: async (): Promise<PatientEnroller[]> => {
      if (!hasuraToken) {
        throw new Error('No authorization token available');
      }

      
      return await pesAdminService.fetchPatientEnrollers(hasuraToken);
    },
    enabled: !!hasuraToken,
    retry: (failureCount, error: any) => {
      return failureCount < 2;
    },
    refetchOnWindowFocus: false,
  });

  return {
    patientEnrollers: data || [],
    isLoading,
    error,
    refetch,
  };
};
